import { dogBreeds } from './dogBreeds';

export const sizeList = [
  { id: 1, value: 'X-Small' },
  { id: 2, value: 'Small' },
  { id: 3, value: 'Medium' },
  { id: 4, value: 'Large' },
  { id: 5, value: 'X-Large' },
  { id: 6, value: 'XX-Large' },
];

export const dogSizeList = [
  { id: 1, value: 'Teacup' },
  { id: 2, value: 'X-Small' },
  { id: 3, value: 'Small' },
  { id: 4, value: 'Small-Medium' },
  { id: 5, value: 'Medium' },
  { id: 6, value: 'Large' },
  { id: 7, value: 'X-Large' },
  { id: 8, value: 'XX-Large' },
];

export const boolYesNoList = [
  { id: 1, value: 'Yes' },
  { id: 2, value: 'No' },
];

export const trainedFor = [
  { id: 1, value: 'Blind' },
  { id: 2, value: 'Deaf' },
  { id: 3, value: 'Physically Disabled' },
];

export const dogSex = [
  { id: 1, value: 'Male' },
  { id: 2, value: 'Female' },
];

export const colorList = [
  { id: 1, value: 'Red' },
  { id: 2, value: 'Blue' },
  { id: 3, value: 'Green' },
  { id: 4, value: 'Yellow' },
  { id: 5, value: 'Orange' },
  { id: 6, value: 'Purple' },
  { id: 7, value: 'Pink' },
  { id: 8, value: 'Brown' },
  { id: 9, value: 'Black' },
  { id: 10, value: 'White' },
  { id: 11, value: 'Gray' },
  { id: 12, value: 'Maroon' },
  { id: 13, value: 'Navy' },
  { id: 14, value: 'Olive' },
  { id: 15, value: 'Cyan' },
  { id: 16, value: 'Magenta' },
  { id: 17, value: 'Turquoise' },
  { id: 18, value: 'Gold' },
  { id: 19, value: 'Silver' },
  { id: 20, value: 'Beige' },
];

export const registerDogForm = [
  {
    id: 'avatar',
    title: "Dog's Avatar",
    subTitle: "Add Your Dog's photo",
    number: '01',
    icon: 'fas fa-image',
    fields: [],
  },
  {
    id: 'information',
    title: 'About your Dog',
    subTitle: 'Tell us about your dog',
    number: '02',
    icon: 'fas fa-info-circle',
    fields: [
      { label: 'Dog Name', id: 'dogName', type: 'text' },
      {
        label: 'Sex',
        id: 'sex',
        type: 'select',
        options: dogSex.map((val) => ({ value: val.value, label: val.value })),
      },
      {
        label: 'Breed',
        id: 'breed',
        type: 'select',
        options: dogBreeds.map((val) => ({
          value: val.value,
          label: val.value,
        })),
      },
      {
        label: 'Dog Color',
        id: 'dogColor',
        type: 'select',
        options: colorList.map((val) => ({
          value: val.value,
          label: val.value,
        })),
      },
      { label: 'Date of Birth', id: 'dob', type: 'date' },
      { label: 'Dog Nicknames', id: 'nickName', type: 'text' },
      { label: 'Describe your Dog', id: 'describeDog', type: 'text' },
      { label: 'Identifying Marks', id: 'identifyingMarks', type: 'text' },
      { label: 'Weight (Kg)', id: 'weight', type: 'number', step: 1 },
      {
        label: 'Dog Size',
        id: 'dogSize',
        type: 'select',
        options: dogSizeList.map((val) => ({
          value: val.value,
          label: val.value,
        })),
      },
      {
        label: 'Collar',
        id: 'collar',
        type: 'select',
        options: boolYesNoList.map((val) => ({
          value: val.value,
          label: val.value,
        })),
      },
      { label: 'Collar ID', id: 'collarID', type: 'text' },
    ],
  },
  {
    id: 'history',
    title: 'Medical & History Information',
    subTitle: "Your dog's medical history",
    number: '03',
    icon: 'fas fa-notes-medical',
    fields: [
      {
        label: 'Medical Issues?',
        id: 'medical',
        type: 'select',
        options: boolYesNoList.map((val) => ({
          value: val.value,
          label: val.value,
        })),
      },
      {
        label: 'Chipped?',
        id: 'chipped',
        type: 'select',
        options: boolYesNoList.map((val) => ({
          value: val.value,
          label: val.value,
        })),
      },
      { label: 'Manufacturer', id: 'manufacturer', type: 'text' },
      { label: 'Chip Number', id: 'chipNumber', type: 'text' },
      {
        label: 'Purebreed?',
        id: 'purebreed',
        type: 'select',
        options: boolYesNoList.map((val) => ({
          value: val.value,
          label: val.value,
        })),
      },
      {
        label: 'History of Agression?',
        id: 'agression',
        type: 'select',
        options: boolYesNoList.map((val) => ({
          value: val.value,
          label: val.value,
        })),
      },
      {
        label: 'Neutered?',
        id: 'neutered',
        type: 'select',
        options: boolYesNoList.map((val) => ({
          value: val.value,
          label: val.value,
        })),
      },
    ],
  },
  {
    id: 'service',
    title: 'Dog Service',
    subTitle: 'Has your dog been in the service of others?',
    number: '04',
    icon: 'fas fa-dog',
    fields: [
      {
        label: 'Active Law Enforcement?',
        id: 'activeLaw',
        type: 'select',
        options: boolYesNoList.map((val) => ({
          value: val.value,
          label: val.value,
        })),
      },
      {
        label: 'Years Served',
        id: 'yearsServed',
        type: 'select',
        options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10+'].map(
          (val) => ({ value: val, label: val })
        ),
      },
      { label: 'Department', id: 'department', type: 'text' },
      { label: 'Law Rank', id: 'lawRank', type: 'text' },
      {
        label: 'Police K9?',
        id: 'PoliceCanine',
        type: 'select',
        options: boolYesNoList.map((val) => ({
          value: val.value,
          label: val.value,
        })),
      },
      {
        label: 'Active Military',
        id: 'activeMilitary',
        type: 'select',
        options: boolYesNoList.map((val) => ({
          value: val.value,
          label: val.value,
        })),
      },
      {
        label: 'Branch Years?',
        id: 'branchYears',
        type: 'select',
        options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10+'].map(
          (val) => ({ value: val, label: val })
        ),
      },
      { label: 'Stationed', id: 'stationed', type: 'text' },
      {
        label: 'Service Dog?',
        id: 'serviceDog',
        type: 'select',
        options: boolYesNoList.map((val) => ({
          value: val.value,
          label: val.value,
        })),
      },
      {
        label: 'Trained?',
        id: 'trainedFor',
        type: 'select',
        options: trainedFor.map((val) => ({
          value: val.value,
          label: val.value,
        })),
      },
    ],
  },
  {
    id: 'adoption',
    title: 'Adoption',
    subTitle: 'Was your dog adopted?',
    number: '05',
    icon: 'fas fa-hand-holding-heart',
    fields: [
      {
        label: 'Adopted?',
        id: 'adopted',
        type: 'select',
        options: boolYesNoList.map((val) => ({
          value: val.value,
          label: val.value,
        })),
      },
      { label: 'Date of Adoption', id: 'dateOfAdoption', type: 'date' },
    ],
  },
];
